import React from 'react'
import useGlobalHook from 'use-global-hook'
import Cookies from 'js-cookie'
import api from 'utils/api'

const authActions = {
	login(store) {
		store.setState({ auth: true })
	},
	logout(store) {
		store.setState({ auth: false })
	},
}

const configActions = {
	async getConfig(store) {
		try {
			const { data } = await api.get('/api/config.php')
			store.setState({ config: data })
		} catch (e) {
			console.error(e)
		}
	},
	setConfig(store, data) {
		store.setState({ config: data })
	},
}

const actions = {
	auth: authActions,
	config: configActions,
}

const initialState = {
	auth: !!Cookies.get('jtp'),
	config: null,
}

const initializer = store => {
	store.actions.config.getConfig()
}

const useGlobal = useGlobalHook(React, initialState, actions, initializer)

export default useGlobal
